// extracted by mini-css-extract-plugin
export default {"loginFailed":"LoginFailed_loginFailed__GIVym","description":"LoginFailed_description__4bgH4"};